import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionReplace from 'react-css-transition-replace';
import logoutIconSrc from '@chama/statics/assets/svg/logout-icon.svg';
import OrderSoundButton from '../../OrderSoundButton';
import Tooltip from '../../Tooltip';
import './index.css';

const propTypes = {
  avatarSrc: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  isSoundMuted: PropTypes.bool.isRequired,
  onSoundClick: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  welcomeMessage: PropTypes.string.isRequired,
  logoutTooltipText: PropTypes.string.isRequired,
  sirenTooltipText: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
};

const UserDisplay = props => {
  const { avatarSrc, username, logout, isSoundMuted, onSoundClick } = props;
  const { isCollapsed, welcomeMessage, logoutTooltipText, sirenTooltipText } = props;
  const renderContent = () => {
    if (isCollapsed) {
      return (
        <div key="collapsed-content" className="UserDisplay__collapsed_content">
          {username.substr(0, 2).toUpperCase()}
        </div>
      );
    }

    return (
      <div key="opened-content" className="UserDisplay__content">
        <div className="UserDisplay__controls_wrapper">
          <Tooltip position="bottom" title={sirenTooltipText}>
            <OrderSoundButton isMuted={isSoundMuted} onClick={onSoundClick} />
          </Tooltip>
          <Tooltip position="bottom" title={logoutTooltipText}>
            <button
              type="button"
              onClick={logout}
              className="UserDisplay__logout u__normalize_button"
            >
              <img src={logoutIconSrc} alt="logout icon" />
            </button>
          </Tooltip>
        </div>
        <div className="UserDisplay__user_info">
          <div className="UserDisplay__avatar" style={{ backgroundImage: `url(${avatarSrc})` }} />
          <div className="UserDisplay__greetings">
            <div>{welcomeMessage || 'Bem vindo(a)!'}</div>
            <div className="UserDisplay__user_name">{username || 'Usuário'}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <CSSTransitionReplace
      component="div"
      className="UserDisplay"
      transitionName="UserDisplay-content-cross-fade"
      transitionEnterTimeout={400}
      transitionLeaveTimeout={400}
    >
      {renderContent()}
    </CSSTransitionReplace>
  );
};

UserDisplay.propTypes = propTypes;

export default UserDisplay;



// WEBPACK FOOTER //
// ../ui-components/components/SideBar/UserDisplay/index.jsx